import { Container } from './Container';
import { Logo } from './Logo';
import { brand, navLinks, services } from '@/content/site';
import styles from './Footer.module.css';

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <Container>
        <div className={styles.top}>
          <div className={styles.about}>
            <Logo />
            <p className={styles.blurb}>
              A senior studio for software that has to work on Monday morning. {brand.tagline}.
            </p>
          </div>

          <nav aria-label="Sections">
            <h2 className={styles.colTitle}>Site</h2>
            <ul className={styles.links}>
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a className={styles.link} href={`#${link.id}`}>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h2 className={styles.colTitle}>Get in touch</h2>
            <ul className={styles.links}>
              <li>
                <a className={styles.link} href={`mailto:${brand.email}`}>
                  {brand.email}
                </a>
              </li>
              {services.map((service) => (
                <li key={service.id}>
                  <a className={styles.link} href="#contact">
                    {service.title} enquiry
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className={styles.bottom}>
          <span>
            &copy; {year} {brand.name}
          </span>
          <span>{brand.location}</span>
        </div>
      </Container>
    </footer>
  );
}
